export default "__VITE_ASSET__B39Pt_Ff__"